import styled from "styled-components";
import { StatusDrawerThemeType } from "../../types";

type StyleProps = {
  left?: string;
  bottom?: string;
  width?: string;
  styles: StatusDrawerThemeType;
};

export const StatusDrawerContainer = styled.div<StyleProps>`
  width: ${(props) => props.width};
  z-index: 1051;
  position: fixed;
  bottom: ${(props) => props.bottom};
  left: ${(props) => props.left};
  box-shadow: ${(props) => props.styles.boxShadow};
  border-radius: ${(props) => props.styles.header.borderRadius};
`;

export const StatusDrawerHeaderContainer = styled.div.attrs(() => ({
  className: "p-2",
}))<StyleProps>`
  background: ${(props) => props.styles.header.background};
  color: ${(props) => props.styles.header.color};
  border-radius: ${(props) => props.styles.header.borderRadius};
`;

export const StatusDrawerBody = styled.div<StyleProps>`
  background: ${(props) => props.styles.body.background};
  border-left: 1px solid ${(props) => props.styles.body.borderColor};
  border-right: 1px solid ${(props) => props.styles.body.borderColor};
`;
